@if (brand !== 'lacarte' && consumption && consumption.date) {
  <div class="text-center w-100 my-consumption-area">
    @if (selectedLine.billStartDate) {
      <h2>Mes consommations DU {{ getDate(consumption, selectedLine, 1) }} @if (consumption.date != getDate(consumption, selectedLine, 2)) {
        <span [className]="environment.data.brand+'-color'">au {{ consumption.date }} </span>
      }</h2>
    }
    <div class="mb-4 procedure-card-area">
      <div [className]="brand === 'prixtel' ? 'col-12' : 'col-12 spacing'">
        <app-procedure-card [icon]="'icons/' + brand + '_consumption_voice.png'" [cursor]="false" [text]="'Appels'" [value]="consumption.total.voice.consumption.toString()"></app-procedure-card>
      </div>
      <div [className]="brand === 'prixtel' ? 'col-12' : 'col-12 spacing'">
        <app-procedure-card [icon]="'icons/' + brand + '_consumption_sms.png'" [cursor]="false" [text]="'SMS/MMS'" [value]="consumption.total.sms.consumption.toString()"></app-procedure-card>
      </div>
      <div [className]="brand === 'prixtel' ? 'col-12' : 'col-12 spacing'">
        <app-procedure-card [icon]="'icons/' + brand + '_consumption_data.png'" [cursor]="false" [text]="'Internet'" [value]="consumption.total.data.consumption.toString()"></app-procedure-card>
      </div>
      @if (brand === 'prixtel') {
        <div class="col-12">
          <app-procedure-card [icon]="'icons/procedure-card-icn-4.png'" [cursor]="false" [text]="'CO2 émis'" [value]="consumption.co2Consumption.total"></app-procedure-card>
        </div>
      }
    </div>
    <div class="w-100 text-left mt-2 mb-3 current-line">
      <p><strong>Forfait : </strong> <span class="offer-name">{{ selectedLine.offer.labelTunnel.toString().replace('.', ',') }} {{ displaySupportInformation ? '[ID - '+selectedLine.offer.id+']' : '' }}</span></p>
      @if (brand == 'prixtel') {
        <p>Mon palier : <span class="offer-name">{{ (consumption.included.price).toFixed(2).toString().replace('.', ',') }}€</span></p>
      }
    </div>
    @if (selectedLine?.offer.id <= environment.data.minOfferId && consumption.shunterPicture) {
      <img [src]="consumption.shunterPicture" class="pt-3 pb-3">
    }
    @if (selectedLine?.offer.id > environment.data.minOfferId) {
      <app-shunters [price]="consumption.included.price" [customPrice]="selectedLine.customSalePriceHT" [shunters]="selectedLine?.offer?.shunters"></app-shunters>
    }
    <div class="total-amount-txt-area"><strong>Montant total de ma facture : </strong>
    <strong class="prixtel-color">{{ priceFormatService.get((consumption.included.price + consumption.notIncluded.price + consumption.services.price).toString()) }}</strong>
    <p class="bill-amount-disclaimer">Ce montant inclut votre forfait et les éventuels services, options et communications hors-forfait.</p>
  </div>
  <button type="button" class="btn-hide-detail cta_btn level_2" (click)="displayDetails()">{{ detailsButtonText }}<span></span></button>
  <app-consumption-details [consumption]="consumption" [hidden]="detailsVisibility"></app-consumption-details>
</div>
}

@if (brand == 'lacarte' && consumption && consumption.counters) {
  <div class="text-center w-100 my-consumption-area">
    @if (getCounters().length > 0) {
      <div class="mb-4 procedure-card-area">
        @for (counter of getCounters(); track counter; let index = $index) {
          <div [className]="getCounters().length > 3 || !consumption.isPrepaid ? 'col-12 spacing-min-cards' : 'col-12 spacing'">
            <app-procedure-card [icon]="getIconCard(counter.label)" [cursor]="false" [text]="counter.label" [value]="counter.value" [longText]="true" [extra]="!counter.label.toLowerCase().includes('wallet') ? 'Valable jusqu\'à ' + counter.expireTime : ''"></app-procedure-card>
          </div>
        }
        @if (!consumption.isPrepaid) {
          <div class="col-12 spacing-min-cards">
            <app-procedure-card [icon]="'icons/' + brand + '_consumption_voice.png'" [cursor]="false" [text]="'Appels'" [value]="consumption.total.voice.consumption.toString()"></app-procedure-card>
          </div>
        }
        @if (!consumption.isPrepaid) {
          <div class="col-12 spacing-min-cards">
            <app-procedure-card [icon]="'icons/' + brand + '_consumption_sms.png'" [cursor]="false" [text]="'SMS/MMS'" [value]="consumption.total.sms.consumption.toString()"></app-procedure-card>
          </div>
        }
        @if (!consumption.isPrepaid) {
          <div class="col-12 spacing-min-cards">
            <app-procedure-card [icon]="'icons/' + brand + '_consumption_data.png'" [cursor]="false" [text]="'Internet'" [value]="consumption.total.data.consumption.toString()"></app-procedure-card>
          </div>
        }
        @if (!consumption.isPrepaid) {
          <div class="col-12 spacing-min-cards">
            <app-procedure-card [icon]="'icons/procedure-card-icn-4-lacarte.png'" [cursor]="false" [text]="'CO2 émis'" [value]="consumption.co2Consumption.total"></app-procedure-card>
          </div>
        }
      </div>
    }
    @if (selectedLine?.offer.id <= environment.data.minOfferId && consumption.shunterPicture) {
      <img [src]="consumption.shunterPicture" class="pt-3 pb-3">
    }
    @if (selectedLine?.offer.id > environment.data.minOfferId) {
      <app-shunters [price]="consumption.included.price" [customPrice]="selectedLine.customSalePriceHT" [shunters]="selectedLine?.offer?.shunters"></app-shunters>
    }
    <div class="total-amount-txt-area"><strong>Montant total de ma facture : </strong>
    <strong class="prixtel-color">{{ priceFormatService.get((consumption.included.price + consumption.notIncluded.price + consumption.services.price).toString()) }}</strong>
    <p class="bill-amount-disclaimer">Ce montant inclut votre forfait et les éventuels services, options et communications hors-forfait.</p>
  </div>
  <button type="button" class="btn-hide-detail cta_btn level_2" (click)="displayDetails()">{{ detailsButtonText }}<span></span></button>
  <app-consumption-details [consumption]="consumption" [hidden]="detailsVisibility"></app-consumption-details>
</div>
}
